export default __webpack_public_path__ + "static/media/0x8c8bdbe9cee455732525086264a4bf9cf821c498.54386691.svg";